import { render, staticRenderFns } from "./BottomPart.vue?vue&type=template&id=8a378b94&scoped=true&"
import script from "./BottomPart.vue?vue&type=script&lang=js&"
export * from "./BottomPart.vue?vue&type=script&lang=js&"
import style0 from "./BottomPart.vue?vue&type=style&index=0&id=8a378b94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a378b94",
  null
  
)

export default component.exports